import { Component, HostListener, ElementRef, QueryList, ViewChildren, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { LoaderService } from "./shared/services/loader.service";
import { LocationService } from "./shared/services/location.service";
import { StoreService } from "./shared/services/store.service";
import { AuthService } from "./auth/auth.service";
import { environment } from "src/environments/environment";
import FlyySDK from "flyy-web-sdk";
import { GlobalService } from "./shared/services/global.service";
import { GoogleMapsLoaderService } from "./shared/services/google-maps-loader.service";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { catchError, filter, map, of, Subscription, take } from "rxjs";
import { UntilDestroy } from "@ngneat/until-destroy";
import { CommonService } from "./shared/services/common.service";
import { ToastrService } from "ngx-toastr";
import { GtmService } from "./shared/services/gtm-service/gtm.service";
import { PwaInstallService } from "./shared/services/pwa-install.service";
import { LoanDashboardService } from "./loan-layout/components/loan-dashboard/loan-dashboard.service";
import { UserPropertiesService } from "src/app/shared/services/user-services/user-properties.service";
import moment from "moment";

@UntilDestroy({ arrayName: "subscriptions" })
@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent {
    permission: boolean = true;
    icon: any;
    apiCalled: boolean = false;
    locationPermission: boolean = false;
    params: any = "";
    network: any;
    subscriptions: Subscription[] = [];
    isSplashScreen = false;

    isMobileOrTablet(): boolean {
        return true;
    }

    isLandscape(): boolean {
        return window.innerWidth > window.innerHeight;
    }

    isMobileTabletLandscape(): boolean {
        return false;
    }

    // Block Ctrl + + / - / =
    // @HostListener("window:keydown", ["$event"])
    // onKeyDown(event: KeyboardEvent) {
    //     if ((event.ctrlKey || event.metaKey) && (event.key === "+" || event.key === "-" || event.key === "=")) {
    //         event.preventDefault();
    //     }
    // }

    // @HostListener("window:keydown", ["$event"])
    // onkeydown(event: KeyboardEvent) {
    //     if ((event.ctrlKey || event.metaKey) && (event.key === "+" || event.key === "-" || event.key === "=")) {
    //         event.preventDefault();
    //     }
    // }

    // @HostListener("window:wheel", ["$event"])
    // onWheel(event: WheelEvent) {
    //     if (event.ctrlKey) {
    //         event.preventDefault();
    //     }
    // }

    menu = [
        { icon: "h", label: "home" },
        { icon: "m", label: "market" },
        { icon: "n", label: "notifications" },
        { icon: "f", label: "favourits" },
        { icon: "u", label: "user" },
    ];

    activeIndex = 0;
    gap = 0;

    @ViewChildren("menuItem", { read: ElementRef })
    items!: QueryList<ElementRef>;

    constructor(
        private dialog: MatDialog,
        public loaderService: LoaderService,
        public locationService: LocationService,
        private store: StoreService,
        private authService: AuthService,
        public globalService: GlobalService,
        private router: Router,
        private googleMapsLoaderService: GoogleMapsLoaderService,
        private commonService: CommonService,
        public toastr: ToastrService,
        private gtmService: GtmService,
        public pwa: PwaInstallService,
        public loanDashboardService: LoanDashboardService,
        public userPropertiesService: UserPropertiesService,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
        private el: ElementRef,
        @Inject(DOCUMENT) private document: Document
    ) {
        setTimeout(() => {
            this.isSplashScreen = false;
        }, 2000);

        this.params = window.location.search;
        //  start flyy here while app load
        let flysdd = new FlyySDK();
        flysdd.startReferralTracking();

        if (environment.production == true) {
            window.console.log = function () {};
            window.console.error = function () {};
            window.console.warn = function () {};
            window.console.time = function () {};
            window.console.timeEnd = function () {};
            this.disableInspect();
        }

        // assign window navigator
        this.network = navigator;

        if (this.network.connection) {
            this.network.connection.addEventListener("change", this.onConnectionChange);
        }

        this.googleMapsLoaderService.load();

        // setInterval(() => {
        //     this.captureLocationPermission();
        // }, 10000);

        let isGeneratedAuthToken = this.store.get("isGeneratedAuthToken");
        if (isGeneratedAuthToken !== "true") {
            // this.captureLocationPermission();
            // // Monitor changes in geolocation permission
            // navigator.permissions.query({ name: "geolocation" as PermissionName }).then((result) => {
            //     result.onchange = () => {
            //         this.captureLocationPermission();
            //     };
            // });
        }

        this.captureLinkParams(this.activatedRoute.snapshot.queryParams);
    }

    private captureLinkParams(routerParams?: any) {
        const hasRouterParams = routerParams && Object.keys(routerParams).length > 0;
        const params = hasRouterParams ? routerParams : this.parseQueryParams(window.location.search);

        // Two steps, strictly ordered. Step 1 compares the link's mobile against the stored
        // session and may call clearAuthStore(), which removes stage / panNumber / dob / email —
        // the exact keys step 2 writes. It returns only once that teardown is complete, and its
        // result is what step 2 runs on, so the order cannot be reshuffled by a later edit.
        //
        // Both are plain synchronous localStorage work. Do NOT turn them into promises: awaiting
        // step 1 would push step 2 into a microtask, past the router's first navigation, and the
        // guards would then read a half-written store — the race this ordering exists to prevent.
        const sessionCleared = this.startSessionForLinkMobile(params);
        this.saveLinkParamsToStore(params, sessionCleared);
    }

    // Links go out with both "email"/"emial" and "repayment"/"rapayment" spellings.
    private pickParam(params: any, keys: string[]): string {
        for (const key of keys) {
            const match = Object.keys(params || {}).find((param) => param.toLowerCase() === key.toLowerCase());
            const value = match ? params[match] : null;
            if (value != null && `${value}`.trim() !== "") return `${value}`.trim();
        }
        return "";
    }

    private parseQueryParams(search: string): any {
        const params: any = {};
        new URLSearchParams(search || "").forEach((value, key) => (params[key] = value));
        return params;
    }

    // Query params are dropped on the first navigate() out of this page, so the link
    // details are stored under the keys the onboarding pages already read.
    private saveLinkParamsToStore(params: any, sessionCleared: boolean = false) {
        if (!params) return;

        const stage = this.pickParam(params, ["stage"]).toLowerCase();
        const rawPan = this.pickParam(params, ["pan", "panNumber"]);
        const rawEmail = this.pickParam(params, ["email", "emial"]);
        const rawDob = this.pickParam(params, ["dateofBirth", "dob"]);

        // Any one of them means a link, and a link starts a fresh run — so clear all four
        // before writing. Without this, a param the new link omits — or sends malformed, so
        // it fails a check below — keeps the previous link's value and autofills stale
        // details. A URL with none of them is left alone: the flow owns these keys then —
        // unless step 1 just tore the session down, because none of the previous user's
        // details may survive into the new one's run.
        if (sessionCleared || stage || rawPan || rawEmail || rawDob) {
            ["stage", "panNumber", "email", "dob"].forEach((key) => this.store.remove(key));
        }

        const normalizedStage = stage === "rapayment" ? "repayment" : stage;
        if (normalizedStage === "repayment" || normalizedStage === "cibil") {
            this.store.set({ key: "stage", value: normalizedStage });
        }

        const panNumber = rawPan.toUpperCase().replace(/[^A-Z0-9]/g, "");
        if (/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panNumber)) {
            this.store.set({ key: "panNumber", value: panNumber });
        }

        const email = rawEmail.toLowerCase();
        if (/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(email)) {
            this.store.set({ key: "email", value: email });
        }

        const dob = moment(rawDob, ["YYYY-MM-DD", "DD-MM-YYYY", "DD/MM/YYYY"], true);
        if (dob.isValid()) {
            this.store.set({ key: "dob", value: dob.format("YYYY-MM-DD") });
        }
    }

    // A link that names a mobile says whose link it is. When someone else is still signed in
    // on this browser — the first user never logged out, the second opens their link in another
    // tab — the guards send that link straight to the signed-in user's dashboard: /auth/login
    // never activates, so LoginComponent's own mobile handling never runs, authMobileNumber
    // keeps the first user's number and the link continues the wrong session.
    //
    // Ending the stale session here is what lets the link reach the login screen at all: this
    // runs in the constructor, before the router's first navigation, so the guards read the
    // cleared store. A session we cannot identify is left alone — never sign a user out on a guess.
    //
    // Returns true once the previous session has been fully torn down, which is the caller's
    // signal that it may start writing the link's own data.
    private startSessionForLinkMobile(params: any): boolean {
        // New data: the number this link belongs to.
        const linkMobile = this.normalizeMobile(this.pickParam(params, ["mobile", "mobileNumber"]));
        if (!/^[6-9][0-9]{9}$/.test(linkMobile)) return false;

        // Stored data: the number the session already in localStorage belongs to.
        const storedMobile = this.getSessionMobile();

        // Compare. Nobody signed in, an unidentifiable session, or the same person → leave it.
        if (!this.hasSession() || !storedMobile || storedMobile === linkMobile) return false;

        // Different person: end the first user's session before the guards can act on it.
        this.globalService.globalChannel.postMessage({ source: "LOGOUT" });
        this.gtmService.clearUserId();
        this.store.clearAuthStore();
        this.dialog.closeAll();
        this.globalService.customerDetails.next({});
        this.loanDashboardService.timelineSubject.next([]);

        // clearAuthStore() drops authMobileNumber as well. Put the link's number back so the
        // login screen still prefills it when a guard redirect strips the query param.
        this.store.set({ key: "authMobileNumber", value: linkMobile });

        return true;
    }

    private hasSession(): boolean {
        return ["token", "m-token"].some((key) => {
            const value = this.store.get(key);
            return !!value && value !== "null" && value !== "undefined";
        });
    }

    // Who the session belongs to. authMobileNumber is what the web login records; mobileNumber
    // and customerDetails cover the app→web token handoff, which never writes it.
    private getSessionMobile(): string {
        let customerDetails: any = {};
        try {
            customerDetails = JSON.parse(this.store.get("customerDetails") || "{}");
        } catch {
            customerDetails = {};
        }

        const mobile =
            this.store.get("authMobileNumber") || this.store.get("mobileNumber") || customerDetails?.mobile || "";

        return this.normalizeMobile(mobile);
    }

    // Both sides of the comparison go through this, so "+91 98765 43210" and "9876543210" match.
    private normalizeMobile(mobile: any): string {
        return `${mobile ?? ""}`.replace(/\D/g, "").slice(-10);
    }

    // navbar methods
    ngAfterViewInit() {
        setTimeout(() => {
            this.calculateGap();
        });
    }

    setActive(index: number, event: Event) {
        event.preventDefault();
        this.activeIndex = index;
    }

    calculateGap() {
        const elements = this.el.nativeElement.querySelectorAll(".bottom-nav-menu li a");

        if (elements.length > 1) {
            const rect1 = elements[0].getBoundingClientRect();
            const rect2 = elements[1].getBoundingClientRect();
            this.gap = rect2.left - rect1.right;
        }
    }

    @HostListener("window:resize")
    onResize() {
        this.calculateGap();
    }
    // navbar methods end

    captureLocationPermission() {
        this.locationService.checkPermission().then((permission) => {
            // this.toastr.warning(`permission ${permission}`);
            if (!permission) {
                // this.globalService.requestLocationPermission();
            } else {
                // this.locationService.captureLocationInBackground();
            }
        });
    }

    async ngOnInit() {
        // Check for token in URL parameters
        // const urlParams = new URLSearchParams(window.location.search);
        // const tokenFromUrl = urlParams.get("token");

        // if (tokenFromUrl) {
        //     this.store.set({ key: "token", value: tokenFromUrl });
        // }

        this.saveQueryParamsToStorageAndCookie();
        this.checkAuthToken();
        this.updateCanonicalUrl();
        // No location prompt on page load; it is asked from the /auth/permission toggle after OTP.
        this.locationService.resumeTrackingIfAllowed();

        this.router.events.subscribe((event) => {
            // console.log(":::event", event);

            if (event instanceof NavigationStart) {
                if (event.navigationTrigger === "popstate") {
                    console.log("🔙 Browser back or forward button clicked");
                }
                this.excludeSidebarRoutesCheck();
            }

            if (event instanceof NavigationEnd) {
                this.excludeSidebarRoutesCheck();
                this.updateCanonicalUrl(event.urlAfterRedirects);

                // Auto-track page_view on every route change
                setTimeout(() => {
                    const pageTitle = this.titleService.getTitle();
                    const pageLocation = window.location.href;
                    const pageReferral = document.referrer || "";

                    this.gtmService.trackPageView(pageTitle, pageLocation, pageReferral);
                }, 0);
            }
        });
    }

    private readonly hideSidebarRoutes: string[] = [
        "/",
        "/auth",
        "/d2c",
        "/loan/employment",
        "/loan/net-banking",
        "/loan/kyc",
        "/loan/soft-approval",
        "/loan/bank-verification",
        "/loan/profile-verification",
        "/loan/e-sign",
        "/loan/e-mandate",
        "/loan/user-approval",
        "/loan/purpose-of-loan",
        "/loan/change-current-address",
        "/loan/disbursement",
        "/loan/repay-successful",
        "/loan/emi-summary",
        "/loan/info",
        "/refer-and-earn",
        "/refer-and-earn/no-referral-history",
        "/refer-and-earn/history",
        "/notifications",
        "/loan/c-kyc",
        "/support/create-query",
        "/support/common-question",
        "/support/chat-room",
        "/support/query-history",
        "/reward-wallet/no-reward-history",
        "/reward-wallet/reward-history",
        "/emi-calculator",
        "/loan/re-take-picture",
        "/loan/loan-declined",
        "/profile",
        "/info",
        "/coming-soon",
        "/cibil-confirmation",
        "/loan/kyc-needed",
        "/more-details/payment-history",
    ];
    private readonly hideHeaderRoutes: string[] = [
        "/",
        "/auth",
        "/d2c",
        "/loan/employment",
        "/loan/net-banking",
        "/loan/kyc",
        "/loan/soft-approval",
        "/loan/bank-verification",
        "/loan/profile-verification",
        "/loan/e-sign",
        "/loan/e-mandate",
        "/loan/user-approval",
        "/loan/purpose-of-loan",
        "/loan/change-current-address",
        "/loan/disbursement",
        "/loan/repay-successful",
        "/history",
        "/loan/emi-summary",
        "/reward-wallet/no-reward-history",
        "/reward-wallet/reward-history",
        "/emi-calculator",
        "/loan/re-take-picture",
        "/loan/info",
        "/support",
        "/support/create-query",
        "/support/query-history",
        "/support/chat-room",
        "/support/common-question",
        "/more-details",
        "/refer-and-earn",
        "/refer-and-earn/no-referral-history",
        "/refer-and-earn/history",
        "/notifications",
        "/loan/loan-declined",
        "/loan/c-kyc",
        "/profile",
        "/info",
        "/coming-soon",
        "/cibil-confirmation",
        "/loan/kyc-needed",
        "/more-details/payment-history",
    ];
    private excludeSidebarRoutesCheck(): void {
        const path = this.router.url.split("?")[0].toLowerCase();

        const shouldHideSidebar = this.hideSidebarRoutes.some(
            (route) => path === route || path.startsWith(route + "/")
        );

        const shouldHideHeader = this.hideHeaderRoutes.some((route) => path === route || path.startsWith(route + "/"));

        this.globalService.showSidebar.next(!shouldHideSidebar);
        this.globalService.showHeader.next(!shouldHideHeader);
    }

    private updateCanonicalUrl(url: string = this.router.url): void {
        const canonicalPath = url.split(/[?#]/)[0] || "/";
        const canonicalUrl = new URL(canonicalPath, "https://loan.myklinq.com").toString();
        let canonicalLink = this.document.querySelector<HTMLLinkElement>('link[rel="canonical"]');

        if (!canonicalLink) {
            canonicalLink = this.document.createElement("link");
            canonicalLink.setAttribute("rel", "canonical");
            this.document.head.appendChild(canonicalLink);
        }

        canonicalLink.setAttribute("href", canonicalUrl);
    }

    disableInspect() {
        document.addEventListener("contextmenu", (event) => event.preventDefault());
        document.addEventListener("keydown", (event) => {
            // F12
            if (event.key === "F12") {
                event.preventDefault();
            }

            // Ctrl + Shift + I
            if (event.ctrlKey && event.shiftKey && event.key === "I") {
                event.preventDefault();
            }

            // Ctrl + Shift + J
            if (event.ctrlKey && event.shiftKey && event.key === "J") {
                event.preventDefault();
            }

            // Ctrl + U (View Source)
            if (event.ctrlKey && event.key === "u") {
                event.preventDefault();
            }

            // Ctrl + Shift + C (Inspect Element)
            if (event.ctrlKey && event.shiftKey && event.key === "C") {
                event.preventDefault();
            }
        });
    }

    checkAuthToken() {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("token");

        if (token && token != "") {
            this.gtmService.clearUserId(); // Clear user ID from GTM
            this.store.clearAuthStore();
            this.dialog.closeAll();
            this.loanDashboardService.timelineSubject.next([]);

            this.store.set({
                key: "token",
                value: token,
            });

            this.store.set({
                key: "isGeneratedAuthToken",
                value: "true",
            });

            this.loaderService.show();
            this.subscriptions.push(
                this.commonService
                    .getCustomerProfile()
                    .pipe(
                        map(async (res: any) => {
                            if (res.success) {
                                let customerDetails = {
                                    customerId: res.data.customerId,
                                    name: res.data.name,
                                    mobile: res.data.mobileNumber,
                                    email: res.data.emailId,
                                    nickName: res.data.nickName,
                                    customerProfile: res.data.customerProfile,
                                };

                                customerDetails.customerProfile = await this.globalService.getBlobFromUrl(
                                    customerDetails.customerProfile
                                );

                                this.userPropertiesService.updateUserProperty("user_address", res.data.address || "");

                                this.store.set({
                                    key: "customerDetails",
                                    value: JSON.stringify(customerDetails),
                                });

                                this.globalService.customerDetails.next(customerDetails);

                                this.store.set({
                                    key: "mobileNumber",
                                    value: res.data.mobileNumber,
                                });

                                this.loaderService.hide();
                                this.loanDashboardService.getDashboardDetails(true);
                            }
                        }),
                        catchError((e) => {
                            this.loaderService.hide();
                            return of(null);
                        })
                    )
                    .subscribe()
            );

            console.log("Token:", token);
        }
        // });
    }

    toggleSidebarForHide() {
        this.globalService.sidebarToggle.next(false);
    }

    // Save query parameters to storage and cookies
    private saveQueryParamsToStorageAndCookie() {
        let queryParams = new URLSearchParams(this.params);
        let paramsObj: any = {};

        queryParams.forEach((value, key) => {
            paramsObj[key] = value;
        });

        if (Object.keys(paramsObj).length > 0) {
            Object.keys(paramsObj).forEach((key) => {
                this.store.set({ key, value: paramsObj[key] });
            });
            this.store.set({ key: "utm_data", value: JSON.stringify(paramsObj) });
        }

        this.saveParamsToStorage(paramsObj, [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_id",
            "utm_term",
            "utm_content",
            "click_id",
            "gclid",
            "gbraid",
            "fbclid",
        ]);
        this.saveParamsToCookies(paramsObj, ["trackingId", "clientIp", "referrer", "deviceId", "code"]);

        // If cookies are missing, handle the user source
        const cookies = this.getCookies();
        if (!this.apiCalled && (!cookies["trackingId"] || !cookies["deviceId"])) {
            this.handleUserSource(paramsObj);
        }
        if (typeof paramsObj.utm_campaign == "string" && paramsObj.utm_campaign.length > 0) {
            let campaign = paramsObj.utm_campaign.toLowerCase().trim();
            if (campaign.includes("pt_klinq_aff")) {
                let code = null;
                if (campaign.includes("spectrum")) code = "spectrum";
                if (campaign.includes("vl")) code = "valueleaf";
                if (campaign.includes("prudigital")) code = "prudigital";
                if (campaign.includes("adsplay")) code = "adsplay";
                if (campaign.includes("theadtalk")) code = "theadtalk";
                if (campaign.includes("adzjunction")) code = "adzjunction";
                if (campaign.includes("vcommission")) code = "vcommission";
                if (campaign.includes("digirovers")) code = "digirovers";
                if (code) this.store.set({ key: "puretech_ma", value: code });
            }
        }
    }

    // Save parameters to storage
    private saveParamsToStorage(queryParams: any, params: string[]) {
        params.forEach((param) => {
            const value = queryParams[param];
            if (value) {
                this.store.set({ key: param, value });
            }
        });
    }

    // Save parameters to cookies
    private saveParamsToCookies(queryParams: any, params: string[]) {
        params.forEach((param) => {
            const value = queryParams[param];
            if (value) {
                this.setCookie(param, value);
            }
        });
    }

    // Get cookies as an object
    private getCookies(): Record<string, string> {
        return document.cookie.split(";").reduce(
            (acc, cookie) => {
                const [key, value] = cookie.split("=").map((c) => c.trim());
                acc[key] = value;
                return acc;
            },
            {} as Record<string, string>
        );
    }

    // Handle user source based on 'utm_source' query parameter
    private handleUserSource(queryParams: any) {
        // Check if 'utm_source' is 'google' and handle the logic accordingly
        const utmSource = queryParams["utm_source"];
        if (utmSource) {
            this.sendDataToApi(queryParams);
        } else {
            this.sendDataToApi(); // Otherwise, send default data
        }
    }

    private getStoredUtmData(): Record<string, any> {
        try {
            const value = this.store.get("utm_data");
            return value ? JSON.parse(value) : {};
        } catch {
            return {};
        }
    }

    // Send the data to the API
    private sendDataToApi(queryParams: any = {}) {
        this.apiCalled = true;
        const storedUtmData = this.getStoredUtmData();
        const data = {
            ...storedUtmData,
            ...queryParams,
            utm_source: queryParams["utm_source"] || storedUtmData["utm_source"] || "direct",
            utm_medium: queryParams["utm_medium"] || storedUtmData["utm_medium"] || "direct",
            utm_campaign: queryParams["utm_campaign"] || storedUtmData["utm_campaign"] || "none",
            utm_id: queryParams["utm_id"] || storedUtmData["utm_id"] || "none",
            utm_term: queryParams["utm_term"] || storedUtmData["utm_term"] || "none",
            utm_content: queryParams["utm_content"] || storedUtmData["utm_content"] || "none",
            gclid: queryParams["gclid"] || storedUtmData["gclid"] || "none",
            click_id: queryParams["click_id"] || storedUtmData["click_id"] || "",
            gbraid: queryParams["gbraid"] || storedUtmData["gbraid"] || "none",
            fbclid: queryParams["fbclid"] || storedUtmData["fbclid"] || "none",
        };
        // Call the userRedirect method of authService
        // temporarily commenting the API call as per the discussion with the team, will uncomment it once we have clarity on the same
        this.authService.userRedirect(data).subscribe({
            next: (res: any) => {
                // console.log("API response:", res);
                if (res.success) {
                    this.saveParamsToCookies(res.data, ["trackingId", "clientIp", "referrer", "deviceId", "code"]);
                }
            },
            error: (err) => {
                console.error("API error:", err);
            },
        });
    }

    // Set a cookie
    private setCookie(name: string, value: string, days: number = 30) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Expiry in milliseconds
        document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    }

    // network speed
    onConnectionChange = () => {
        if (navigator.onLine) {
            const { effectiveType } = this.network.connection;
            if (effectiveType === "2g" || effectiveType === "slow-2g") {
                this.dialog.closeAll();
                this.globalService.internetConnection();
            }
        } else if (!navigator.onLine) {
            this.dialog.closeAll();
            this.globalService.internetConnection();
        }
    };
}
